import { EnvironmentType, ExceptionCode } from "@/enums/enums";
import { i18n } from "@/i18n";

export function NewObject(obj: any) {
  if (obj == "") {
    return "";
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}
export function CheckIsDevelop() {
  const typeEnv = Number(process.env.VUE_APP_TYPE_ENV);
  if (!isNaN(typeEnv)) {
    return typeEnv <= EnvironmentType.SIT;
  }
  return false;
}
export function GetMessageExceptionCode(exception: any) {
  let message: any = "";
  switch (exception.code) {
    case ExceptionCode.AssetTemplateCodeDuplicated:
      message = i18n.t("Asset_Group_Code_Already_Been_Used");
      break;
    case ExceptionCode.ImportTransactionExceed:
      message = i18n.t("ImportTransaction_Exceed");
      break;
    case ExceptionCode.LockByPeriod:
      message = i18n.t("Lock_old_entries", { date: exception.content.GetDateFormat() });
      break;
    case ExceptionCode.PurchaseDateLessThanDepreciateDate:
      message = i18n.t("Alert_PurchaseDateLessThanDepreciateDate");
      break;
    default:
      message = ExceptionCode
        ? `${i18n.t("Something_Wrong")} Error Code : ${ExceptionCode}`
        : i18n.t("Something_Wrong");
      break;
  }
  return message;
}
export function DecodeJwtResponse(credential: any) {
  return JSON.parse(atob(credential.split(".")[1]).toString());
}

function DetectTabClosing(e: any) {
  const confirmationMessage = "";

  (e || window.event).returnValue = confirmationMessage;
  return confirmationMessage;
}

export function AddDetectTabClosing() {
  window.addEventListener("beforeunload", DetectTabClosing);
}
export function RemoveDetectTabClosing() {
  window.removeEventListener("beforeunload", DetectTabClosing);
}

export function GetUserIdFromCommentText(commentText: string) {
  if (commentText) {
    const userIds = commentText.match(/\[\[userId\d+\]\]/g);
    if (userIds) {
      const extractedUserIds = userIds.map((userId: any) => Number(userId.match(/\d+/)[0]));
      return extractedUserIds;
    }
  }
  return [];
}

export function GetCommentTextForDisplay(commentText: string, userIdListForMap: Map<number, any>) {
  let commentTextForDisplay = commentText;
  if (commentText) {
    const userIds: any = commentText.match(/\[\[userId\d+\]\]/g);
    if (userIds && userIds.length > 0) {
      for (const userId of userIds) {
        const extractedUserId = Number(userId.match(/\d+/)[0]);
        const selectedUser = userIdListForMap.get(extractedUserId);
        if (selectedUser) {
          const userNameBox = `<span style="color:#3297ff;font-family: 'Maibork-bold';">@${selectedUser.displayName}</span>`;
          commentTextForDisplay = commentTextForDisplay.replaceAll(userId, userNameBox);
        }
      }
    }
  }
  return commentTextForDisplay;
}
